import methods from './methods'

export { methods }

export default {
  ...methods
}
